export type SketchfabOAuthCallbackResult = {
  status: "success" | "failure";
  reason: string | null;
  nextUrl: string;
};

const SKETCHFAB_WORKSPACE_PATH = "/artwork/list";

const normalizeSearch = (search: string): string =>
  search.startsWith("?") ? search.slice(1) : search;

export const consumeSketchfabOAuthCallback = ({
  pathname,
  search,
  hash = "",
}: {
  pathname: string;
  search: string;
  hash?: string;
}): SketchfabOAuthCallbackResult | null => {
  const params = new URLSearchParams(normalizeSearch(search));
  const provider = params.get("provider");
  const status = params.get("status");

  if (provider !== "sketchfab" || (status !== "success" && status !== "failure")) {
    return null;
  }

  const reason = params.get("reason");

  params.delete("provider");
  params.delete("status");
  params.delete("reason");
  params.delete("skView");
  params.set("tab", "sketchfab-import");
  params.set("artView", "list");

  const nextSearch = params.toString();

  return {
    status,
    reason,
    nextUrl: `${SKETCHFAB_WORKSPACE_PATH}${nextSearch ? `?${nextSearch}` : ""}${hash}`,
  };
};
